
    import _Handlebars from 'handlebars/runtime';
    var Handlebars = _Handlebars.default;
    import "i18n!assignment_details_dialog";
import "coffeescripts/handlebars_helpers.coffee";

    var template = Handlebars.template, templates = Handlebars.templates = Handlebars.templates || {};
    var name = 'AssignmentDetailsDialog';
    templates[name] = template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", stack1, helper, options, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression, functionType="function", self=this;

function program1(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n    <div class=\"distribution\" style=\"display: block; \">\n      <div class=\"bar-left\"></div>\n      <div class=\"none-left\" title=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'min': ((depth0 && depth0.min)),
    'scope': ("assignment_details_dialog")
  },data:data},helper ? helper.call(depth0, "no_one_scored_lower", "No one scored lower than %{min}", options) : helperMissing.call(depth0, "t", "no_one_scored_lower", "No one scored lower than %{min}", options)))
    + "\" style=\"width: ";
  if (helper = helpers.noneLeftWidth) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.noneLeftWidth); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "%; left: ";
  if (helper = helpers.noneLeftLeft) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.noneLeftLeft); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "%; \"></div>\n      <div class=\"some-left\" title=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'average': ((depth0 && depth0.average)),
    'scope': ("assignment_details_dialog")
  },data:data},helper ? helper.call(depth0, "scores_lower_than_the_average", "Scores lower than the average of %{average}", options) : helperMissing.call(depth0, "t", "scores_lower_than_the_average", "Scores lower than the average of %{average}", options)))
    + "\" style=\"width: ";
  if (helper = helpers.someLeftWidth) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.someLeftWidth); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "%; left: ";
  if (helper = helpers.someLeftLeft) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.someLeftLeft); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "%; \"></div>\n      <div class=\"some-right\" title=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'average': ((depth0 && depth0.average)),
    'scope': ("assignment_details_dialog")
  },data:data},helper ? helper.call(depth0, "scores_higher_than_the_average", "Scores higher than the average of %{average}", options) : helperMissing.call(depth0, "t", "scores_higher_than_the_average", "Scores higher than the average of %{average}", options)))
    + "\" style=\"width: ";
  if (helper = helpers.someRightWidth) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.someRightWidth); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "%; left: ";
  if (helper = helpers.someRightLeft) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.someRightLeft); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "%; \"></div>\n      <div class=\"none-right\" title=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'max': ((depth0 && depth0.max)),
    'scope': ("assignment_details_dialog")
  },data:data},helper ? helper.call(depth0, "no_one_scored_higher", "No one scored higher than %{max}", options) : helperMissing.call(depth0, "t", "no_one_scored_higher", "No one scored higher than %{max}", options)))
    + "\" style=\"width: ";
  if (helper = helpers.noneRightWidth) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.noneRightWidth); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "%; left: ";
  if (helper = helpers.noneRightLeft) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.noneRightLeft); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "%; \"></div>\n      <div class=\"bar-right\"></div>\n    </div>\n  ";
  return buffer;
  }

  buffer += "<div id=\"assignment-details-dialog\" title=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'assignment.name': (((stack1 = (depth0 && depth0.assignment)),stack1 == null || stack1 === false ? stack1 : stack1.name)),
    'scope': ("assignment_details_dialog")
  },data:data},helper ? helper.call(depth0, "grading_statistics_for_assignment", "Grade statistics for: %{assignment.name}", options) : helperMissing.call(depth0, "t", "grading_statistics_for_assignment", "Grade statistics for: %{assignment.name}", options)))
    + "\">\n  ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.showDistribution), {hash:{},inverse:self.noop,fn:self.program(1, program1, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n  <table id=\"assignment-details-dialog-stats-table\">\n    <tr>\n      <th scope=\"row\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("assignment_details_dialog")
  },data:data},helper ? helper.call(depth0, "average_score", "Average Score:", options) : helperMissing.call(depth0, "t", "average_score", "Average Score:", options)))
    + "</th>\n      <td>";
  if (helper = helpers.average) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.average); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "</td>\n    </tr>\n    <tr>\n      <th scope=\"row\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("assignment_details_dialog")
  },data:data},helper ? helper.call(depth0, "high_score", "High Score:", options) : helperMissing.call(depth0, "t", "high_score", "High Score:", options)))
    + "</th>\n      <td>";
  if (helper = helpers.max) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.max); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "</td>\n    </tr>\n    <tr>\n      <th scope=\"row\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("assignment_details_dialog")
  },data:data},helper ? helper.call(depth0, "low_score", "Low Score:", options) : helperMissing.call(depth0, "t", "low_score", "Low Score:", options)))
    + "</th>\n      <td>";
  if (helper = helpers.min) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.min); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "</td>\n    </tr>\n    <tr>\n      <th scope=\"row\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("assignment_details_dialog")
  },data:data},helper ? helper.call(depth0, "total_graded_submissions", "Total Graded Submissions:", options) : helperMissing.call(depth0, "t", "total_graded_submissions", "Total Graded Submissions:", options)))
    + "</th>\n      <td>"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'cnt': ((depth0 && depth0.cnt)),
    'scope': ("assignment_details_dialog")
  },data:data},helper ? helper.call(depth0, "count_of_submissions", "%{cnt} submissions", options) : helperMissing.call(depth0, "t", "count_of_submissions", "%{cnt} submissions", options)))
    + "</td>\n    </tr>\n  </table>\n</div>\n";
  return buffer;
  });
    ;
    
    import brandableCss from 'compiled/util/brandableCss';
    brandableCss.loadStylesheet('jst/AssignmentDetailsDialog', {"new_styles_normal_contrast":{"combinedChecksum":"4b0bfe7001"},"new_styles_high_contrast":{"combinedChecksum":"4b0bfe7001"},"responsive_layout_normal_contrast":{"combinedChecksum":"4b0bfe7001"},"responsive_layout_high_contrast":{"combinedChecksum":"4b0bfe7001"},"new_styles_normal_contrast_rtl":{"combinedChecksum":"1fc99fd00c"},"new_styles_high_contrast_rtl":{"combinedChecksum":"1fc99fd00c"},"responsive_layout_normal_contrast_rtl":{"combinedChecksum":"1fc99fd00c"},"responsive_layout_high_contrast_rtl":{"combinedChecksum":"1fc99fd00c"}}[brandableCss.getCssVariant()]);
  ;
    export default templates[name];
  